import React from "react";
import cn from "classnames";
import UITable, {UITableBody, UITableCell, UITableHead, UITableLinkCell, UITableRow} from "~/old-ui/UITable";
import {createUseStyles} from "react-jss";
import {brandColor, primaryTextColor, secondaryTextColor} from "~/theme";
import {reverse} from "~/urls";
import {buildQueryString, range} from "~/utils";
import gql from "graphql-tag";
import {UILineSkeleton} from "~/old-ui/UISkeleton";
import ReactLink from "~/components/ReactLink";
import UILabel from "../old-ui/UILabel";


export default function AccountListTable({loading, loadingRows, data, context}) {
  const classes = useStyles();

  return (
    <UITable responsive>
      <UITableHead>
        <UITableRow>
          <UITableCell className={classes.accountCell}>Account</UITableCell>
          <UITableCell className={classes.locationCell}>Type</UITableCell>
          <UITableCell className={classes.statusCell}>Trial</UITableCell>
          <UITableCell primary/>
        </UITableRow>
      </UITableHead>

      <UITableBody>
        {!loading && data.map((item) => <AccountTableRow key={item.id} item={item} context={context}/>)}

        {loading && (
          range(loadingRows).map((i) => (<AccountTableLoadingRow key={i}/>))
        )}

        {(!loading && (!data || data.length === 0)) && (
          <AccountTableMessageRow>No table data</AccountTableMessageRow>
        )}
      </UITableBody>
    </UITable>
  );
}

AccountListTable.fragments = {
  item: gql`
    fragment AccountTableItem on Account {
      id
      name
      __typename
      active
      isTrial
    }
  `
};


function AccountTableRow({item, context, className, ...props}) {
  const classes = useStyles();
  const detailUrl = reverse('accounts_detail', {id: item.id})
    + (context ? ('?' + buildQueryString({'list_ctx': context})) : '');

  return (
    <UITableRow key={item.id} className={cn(classes.row, className)}>
      <UITableLinkCell component={ReactLink} to={detailUrl} className={classes.accountCell}>
        <div className={classes.primaryValue}>
          {item.name}
          {!item.active && ( <>&nbsp;<UILabel small danger>inactive</UILabel></>)}
          {item.isTrial && (<>&nbsp;<UILabel small warning>trial</UILabel></>)}
        </div>
      </UITableLinkCell>
      <UITableLinkCell component={ReactLink} className={classes.locationCell} to={detailUrl} noWrap>
        {item.__typename}
      </UITableLinkCell>
      <UITableLinkCell component={ReactLink} to={detailUrl} className={classes.statusCell}>
        {item.isTrial}
        {/*{prettifyParticipationStatus(item.status)}*/}
      </UITableLinkCell>
      {/*<UITableLinkCell component={ReactLink} className={classes.paidCell} to={detailUrl} noWrap>*/}
      {/*  {(item.paidAmount && item.isPaid) ? <UIIcon className={classes.checkIcon} name='fa-check'/> : ''}*/}
      {/*</UITableLinkCell>*/}
      {/*<UITableLinkCell component={ReactLink} to={detailUrl} className={classes.ratingCell} noWrap>*/}
      {/*  {item.evaluation ? `${item.evaluation.rating} of 10` : ''}*/}
      {/*</UITableLinkCell>*/}

      <UITableLinkCell component={ReactLink} to={detailUrl} primary/>
    </UITableRow>
  )
}

function AccountTableLoadingRow({className, ...props}) {
  const classes = useStyles();

  return (
    <UITableRow className={cn(classes.row, className)} {...props}>
      <UITableCell>
        <UILineSkeleton width={260}/>
        <UILineSkeleton width={200}/>
      </UITableCell>
      <UITableCell noWrap>
        <UILineSkeleton width={200}/>
      </UITableCell>
      <UITableCell>
        <UILineSkeleton width={100}/>
      </UITableCell>
      <UITableCell noWrap>
        <UILineSkeleton width={34}/>
      </UITableCell>
      <UITableCell noWrap>
        <UILineSkeleton width={68}/>
      </UITableCell>

      <UITableCell primary/>
    </UITableRow>
  )
}

function AccountTableMessageRow() {
  const classes = useStyles();

  return (
    <UITableRow>
      <UITableCell colSpan={6}>
        <div className={classes.message}>
          No table data
        </div>
      </UITableCell>
    </UITableRow>
  )
}

const useStyles = createUseStyles({
  row: {
    '&:hover td': {
      backgroundColor: '#f0f0f0',
    }
  },

  accountCell: {
    minWidth: 320,
    maxWidth: 320,
  },

  locationCell: {
    minWidth: 240,
    maxWidth: 240,
  },

  statusCell: {
    minWidth: 140,
    maxWidth: 140,
  },

  paidCell: {
    minWidth: 68,
    maxWidth: 68,
    textAlign: 'center',
  },

  ratingCell: {
    minWidth: 100,
    maxWidth: 100,
  },

  message: {
    textAlign: 'center',
    color: secondaryTextColor,
    paddingTop: 24,
    paddingBottom: 24,
  },

  primaryValue: {
    fontWeight: 500,
    color: primaryTextColor,
  },

  secondaryValue: {
    fontWeight: 500,
    paddingTop: 10,
    color: secondaryTextColor,
    whiteSpace: 'nowrap',
    maxWidth: 280,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  checkIcon: {
    color: brandColor,
    display: 'inline-block',
  },

  eventPrivacyIcon: {
    display: 'inline-block',
    marginBottom: -3,
    color: secondaryTextColor,
  }
});
